exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tinymce-wrapper .mce-path{display:none}.tinymce-wrapper .mce-statusbar{border-bottom:0;border-right:0;border-left:0}.tinymce-wrapper .mce-statusbar>.mce-container-body{padding-right:0}.tinymce-wrapper .mce-charactercount{margin-left:auto;font-size:12px;padding:3px 2px 0 0}.tinymce-wrapper .mce-tinymce{border-width:0!important}.tinymce-wrapper .mce-toolbar-grp{border-top-width:1px;border-right-width:1px;border-left-width:1px}.tinymce-wrapper .mce-edit-area{border-width:1px 1px 0!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/wysiwyg/tinymce/component/tinymce-wrapper.component.css
 ** module id = 74
 ** module chunks = 0 1
 **/